'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'sun-bright';
var width = 512;
var height = 512;
var aliases = ["sun-alt"];
var unicode = 'e28f';
var svgPathData = ['M152 256a104 104 0 1 0 208 0 104 104 0 1 0 -208 0z', 'M264 0l0 8 0 96 0 8-16 0 0-8 0-96 0-8 16 0zM0 248l8 0 96 0 8 0 0 16-8 0L8 264l-8 0 0-16zm400 0l8 0 96 0 8 0 0 16-8 0-96 0-8 0 0-16zM264 400l0 8 0 96 0 8-16 0 0-8 0-96 0-8 16 0zM80.6 69.3L86.3 75l67.9 67.9 5.7 5.7-11.3 11.3-5.7-5.7L75 86.3l-5.7-5.7L80.6 69.3zm-11.3 362l5.7-5.7 67.9-67.9 5.7-5.7 11.3 11.3-5.7 5.7L86.3 437l-5.7 5.7L69.3 431.4zM352.2 148.5l5.7-5.7L425.7 75l5.7-5.7 11.3 11.3L437 86.3l-67.9 67.9-5.7 5.7-11.3-11.3zm11.3 203.6l5.7 5.7L437 425.7l5.7 5.7-11.3 11.3-5.7-5.7-67.9-67.9-5.7-5.7 11.3-11.3zM360 256a104 104 0 1 0 -208 0 104 104 0 1 0 208 0zm-224 0a120 120 0 1 1 240 0 120 120 0 1 1 -240 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSunBright = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;